webpackJsonp([5],{

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(108);

var _reactHelmet = __webpack_require__(159);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsPage = (0, _reactStatic.withRouteData)(function (_ref) {
  var news = _ref.news;


  var uri = 'https://afrodesiamedia.com/';
  // console.log(news)

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        'title',
        null,
        ' News - afrodesiamedia'
      ),
      _react2.default.createElement('link', { rel: 'shortcut icon', href: '/favicon.ico' }),
      _react2.default.createElement('meta', { property: 'og:url', content: 'https://afrodesiamedia.com' }),
      _react2.default.createElement('meta', { property: 'og:title', content: 'News' })
    ),
    _react2.default.createElement(
      'section',
      { className: 'News' },
      _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'div',
          { className: 'news-list' },
          news.map(function (n, index) {
            return _react2.default.createElement(
              'article',
              { key: index },
              _react2.default.createElement(
                _reactStatic.Link,
                { to: '/news/' + n.permUrl, alt: n.newsTitle },
                _react2.default.createElement(
                  'figure',
                  { className: 'img-const' },
                  _react2.default.createElement('img', { src: '' + uri + n.featuredImage.path, alt: n.newsTitle })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'date' },
                  n.date
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'news-ref' },
                  _react2.default.createElement(
                    'p',
                    null,
                    n.newsTitle,
                    ' '
                  )
                )
              )
            );
          })
        )
      )
    )
  );
});

exports.default = NewsPage;

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/News/components/NewsPage.0588055f.js